//@ts-nocheck
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { postRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import Cookies from "js-cookie";
import { getErrorMessage } from "../../utils/getErrorMessage";
import {
    hasAuthAccountLockError,
    resolveAuthFlowErrorMessage,
} from "../../utils/user-account-login-lock";
import { GlobalVariables, GlobalConstants } from "../../utils/constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { decryptValue, encryptValue } from "../../utils/app-utils";
import Router from "@jack-henry/web-component-router";
import { routerConfig } from "../../routers";
import { AppRouters } from "../../utils/app-router";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { setUserSessionCookies } from "../../utils/setUserSessionCookies";
import { updateLaunchDarklyUserContext } from "../../utils/launchdarkly-helpers";

@customElement("multi-factor-auth")
export class MultiFactorAuth extends formElementMixin(LitElement) {
    constructor() {
        super();
    }
    @property({ type: Number })
    timerValue = GlobalConstants.OTPTimerValue;
    @property({ type: Boolean })
    isActive = true;
    @property({ type: Object })
    formData = {
        authCode: "",
    };
    @property({ type: Boolean })
    apiLoading = false;
    @property({ type: Boolean })
    timeUp = false;
    @property({ type: Object })
    loginFormData = {
        userId: '',
        password: '',
        session: ''
    };
  @property({type: String})
    errorMsg = "Code expired. Please click Resend Code button to get a new one."
  @property({type: Boolean})
    maxedOut = false;

  @property({ type: Function })
  onLoginClick;
    
    timerId = null;
    static get styles() {
        return [
            css`
        jha-card {
          width: 508px;
          padding: 48px;
          position: relative;
          border-radius: 23px;
        }
        img {
          width: 112px;
          height: 112px;
        }
        #loginBg {
          background-color: #06185f;
          display: flex;
          align-items: center;
          height: 100vh;
          width: 100vw;
        }
        jha-form-row {
          margin-top: 50px;
          margin-bottom: 50px;
        }
        #avatarDiv {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        #submitBtn {
          width: 90px;
        }
      `,
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this.startTimer();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stopTimer();
    }
    startTimer() {
        this.timerId = setInterval(() => {
            if (this.isActive && this.timerValue > 0) {
                this.timerValue -= 1;
            } else if (this.timerValue === 0) {
                this.stopTimer();
            }
            this.requestUpdate();
        }, 1000);
    }
    stopTimer() {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
        this.isActive = false;
        this.timeUp = true;
    }
    formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
            2,
            "0"
        )}`;
    }
    async onVerifyClick() {
        this.apiLoading = true;
        const headers = {
            Authorization:
                "Basic " +
                btoa(this.loginFormData.userId.trim() + ":" + this.loginFormData.session),
            "X-Frame-Options": "sameorigin",
            "Content-Security-Policy": "self",
            "Content-Type": "application/json",
        };
    const onVerifyOtp = await postRequest<{UserOTP:string}>(Apis.VERIFY_OTP, {
            UserOTP: this.formData.authCode,
    },headers);
        if (onVerifyOtp?.messageStatus === null) {
            this.apiLoading = false;
            setUserSessionCookies(onVerifyOtp);
            void updateLaunchDarklyUserContext();
            const router = new Router(routerConfig);
            if (AppRouters.page.current.includes("/users")) {
                window.location.reload();
            } else {
                router.go("/users");
            }
        } else if (onVerifyOtp?.details?.length > 0) {
            if (
                onVerifyOtp.details[0].code === StatusConstants.MFA_MAX_ATTEMPT_CODE
            ) {
                this.apiLoading = false;
                const errMsg = getErrorMessage(onVerifyOtp?.details);
                this.errorMsg = errMsg + " Redirecting back to Login page in 3 seconds ...";
                this.timeUp = true;
                this.maxedOut = true;
                clearInterval(this.timerId);
                showToast({
                    message: errMsg,
                    role: "danger",
                    duration: GlobalVariables.TOAST_TIMEOUT,
                });
                setTimeout(() => {
                    this.onCancelClick();
                }, 3000);
            } else {
                this.apiLoading = false;
                const errMsg = resolveAuthFlowErrorMessage(
                    onVerifyOtp?.details,
                    getErrorMessage,
                );
                const isAccountLock = hasAuthAccountLockError(onVerifyOtp?.details);
                if (isAccountLock) {
                    this.errorMsg = errMsg;
                    this.maxedOut = true;
                    this.stopTimer();
                }
                showToast({
                    message: errMsg,
                    role: "danger",
                    duration: GlobalVariables.TOAST_TIMEOUT,
                });
            }
        } else {
            this.apiLoading = false;
            showToast({
                message: "Something went wrong, please try again.",
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        }
    }

    onKeyPress(e: Event) {
        if (e.type === 'keypress' && this.formData.authCode.length == 6) {
            const k = e as KeyboardEvent
            if (k.key === 'Enter') {
                this.onVerifyClick();
            }
        }
    }

    async onResendClick() {
      
 try {
  if (typeof this.onLoginClick === 'function') {
    await this.onLoginClick(); 
  }
  clearInterval(this.timerId);
            this.timeUp = false;
            this.timerValue = GlobalConstants.OTPTimerValue;
            this.isActive = true;
            this.startTimer();
            showToast({
                message: "A new OTP has been sent to registered email.",
                role: "success",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
          } catch (e) { 
            this.apiLoading = false;
            showToast({
                message: "Something went wrong, please try again.",
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        }
    }
    handleInputChange(e) {
        this.formData.authCode = e.target.value;
        this.formValid = this.formData.authCode?.trim().length === 6;
      }
    onCancelClick() {
        this.dispatchEvent(
            new CustomEvent("authCancelClick", {
                detail: true,
                bubbles: true,
                composed: true,
            })
        );
    }
    render() {
        return html`
    ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="loginBg">
          <jha-card>
            <form>
              <div id="avatarDiv">
                <img src="/jha-logo.png" alt="JHA" />
              </div>
              <jha-form-row>
                <div id="avatarDiv">
                  <h2>Multi-Factor Authentication (MFA)</h2>
                </div>
              </jha-form-row>
              <jha-form-row>
                <div id="avatarDiv">
                  <h3>
                    A verification code has been sent to your registered email. </br>
                    Please enter the code and click on Verify button to validate.
                  </h3>
                </div>
              </jha-form-row>
              <jha-form-row>
                <jha-form-input
                  data-auto-id="authInput"
                  label="Verification Code"
                  required
                  warning="Verification Code is required."
                  type="text"
                  maxlength="6"
                  minlength="6"
                  data-id="authCode"
                  allowedCharacters="^[0-9]{0,6}$"
                  .value=${this.formData.authCode}
                  @input=${this.handleInputChange}
                  @keypress=${this.onKeyPress}
                  outline
                >
                </jha-form-input>
              </jha-form-row>
              <jha-form-row>
              ${this.timeUp
                ? html`
                      <strong
                        >${this.errorMsg}</strong
                      >
                    `
                : html`<strong
                      >The code expires in ${this.formatTime(this.timerValue)}
                      minutes.</strong
                    >`
            }
              </jha-form-row>
              <jha-form-row>
              <jha-button
                  data-auto-id="verifyBtn"
                  large
                  type="submit"
                  ?disabled=${!this.formValid || this.maxedOut}
                  sync
                  @click=${this.onVerifyClick}
                  >Verify</jha-button
                >
              </jha-form-row>
              <jha-form-row>
              <jha-button
                  data-auto-id="resendBtn"
                  large
                  outline
                  type="button"
                  sync
                  ?disabled=${this.maxedOut}
                  @click=${this.onResendClick}
                  >Resend Code</jha-button
                >
                <jha-button
                  data-auto-id="cancelBtn"
                  large
                  outline
                  type="button"
                  sync
                  @click=${this.onCancelClick}
                  >Cancel</jha-button
                >
              </jha-form-row>
            </form>
          </jha-card>
        </div>`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "multi-factor-auth": MultiFactorAuth;
    }
}
